import {BaseEntity} from "./BaseEntity";


export class ClientApp implements  BaseEntity
{
    constructor(public id?: number,
                public clientID?: string,
                public grantType?: string,
                public allowRefreshTokens?: boolean,
                public secret?: string) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.clientID = json.clientID;
        this.grantType = json.grantType;
        this.allowRefreshTokens = json.allowRefreshTokens;
        this.secret = json.secret;
    }


}
